var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyfvsdlogostacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 690.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.64,531.37v31.88c0,2.27-1.84,4.11-4.11,4.11h-55.12c-2.27,0-4.11,1.84-4.11,4.11v14.11c0,2.27,1.84,4.11,4.11,4.11h37.35c2.27,0,4.11,1.84,4.11,4.11v29.83c0,2.27-1.84,4.11-4.11,4.11h-37.35c-2.27,0-4.11,1.84-4.11,4.11v52.61c0,2.27-1.84,4.11-4.11,4.11h-42.36c-2.27,0-4.11-1.84-4.11-4.11v-153.08c0-2.27,1.84-4.11,4.11-4.11h105.69c2.27,0,4.11,1.84,4.11,4.11Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.35,532.68l-51.46,153.08c-.56,1.67-2.13,2.8-3.9,2.8h-59.48c-1.77,0-3.33-1.13-3.9-2.8l-51.46-153.08c-.9-2.66,1.09-5.42,3.9-5.42h44.99c1.82,0,3.42,1.19,3.94,2.93l28.43,94.85c1.17,3.91,6.71,3.91,7.88,0l28.24-94.83c.52-1.74,2.12-2.94,3.94-2.94h44.98c2.81,0,4.79,2.76,3.9,5.42Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.94,676.6c-11.4-8.22-18.05-19.92-19.96-35.11-.31-2.46,1.62-4.64,4.09-4.64h45.59c1.96,0,3.72,1.34,4.09,3.26,1.4,7.09,5.35,10.64,11.86,10.64,2.73,0,5.05-.64,6.95-1.93,1.9-1.29,2.85-3.3,2.85-6.04,0-3.8-2.05-6.87-6.15-9.23-4.1-2.35-10.48-5.05-19.14-8.09-10.33-3.64-18.87-7.21-25.63-10.71-6.76-3.49-12.57-8.58-17.43-15.27-4.86-6.68-7.22-15.27-7.06-25.74,0-10.48,2.7-19.4,8.09-26.77,5.39-7.37,12.76-12.95,22.1-16.74,9.34-3.8,19.86-5.7,31.55-5.7,19.74,0,35.43,4.56,47.05,13.67,10.53,8.26,16.54,19.58,18.03,33.96.25,2.42-1.67,4.54-4.1,4.54h-46.33c-1.95,0-3.69-1.36-4.02-3.29-.49-2.88-1.53-5.05-3.1-6.51-2.13-1.97-4.71-2.96-7.75-2.96-2.13,0-3.87.72-5.24,2.16-1.37,1.45-2.05,3.46-2.05,6.04,0,3.65,2.01,6.65,6.04,9,4.02,2.36,10.44,5.2,19.25,8.54,10.17,3.8,18.57,7.44,25.17,10.93,6.61,3.5,12.34,8.36,17.2,14.58,4.86,6.23,7.29,14.05,7.29,23.47,0,9.88-2.43,18.72-7.29,26.54-4.86,7.82-11.92,13.94-21.19,18.34-9.26,4.41-20.28,6.61-33.03,6.61-19.29,0-35.2-4.52-47.73-13.56Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.47,537.51c12.68,6.83,22.44,16.33,29.28,28.48,6.83,12.15,10.25,25.97,10.25,41.46s-3.42,29.16-10.25,41.47c-6.83,12.3-16.6,21.98-29.28,29.05-12.68,7.06-27.45,10.59-44.31,10.59h-63.1c-2.27,0-4.11-1.84-4.11-4.11v-153.08c0-2.27,1.84-4.11,4.11-4.11h63.1c16.86,0,31.63,3.42,44.31,10.25ZM738.71,634.11c6.68-6.23,10.03-15.11,10.03-26.66s-3.34-20.42-10.03-26.65c-6.69-6.23-15.72-9.34-27.11-9.34h-7.96c-2.27,0-4.11,1.84-4.11,4.11v63.77c0,2.27,1.84,4.11,4.11,4.11h7.96c11.39,0,20.43-3.11,27.11-9.34Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.82,599.65v86.27c0,1.46-1.18,2.64-2.64,2.64h-13.08c-1.46,0-2.64-1.18-2.64-2.64v-43.56c0-2.89-3.98-3.68-5.08-1.01l-18.77,45.57c-.41.99-1.37,1.64-2.44,1.64h-10.37c-1.07,0-2.03-.64-2.44-1.63l-18.9-45.65c-1.11-2.67-5.08-1.88-5.08,1.01v43.63c0,1.46-1.18,2.64-2.64,2.64H2.64c-1.46,0-2.64-1.18-2.64-2.64v-86.27c0-1.46,1.18-2.64,2.64-2.64h16.47c1.06,0,2.01.63,2.43,1.6l26.01,60.79c.91,2.14,3.94,2.14,4.86,0l26-60.79c.42-.97,1.37-1.6,2.43-1.6h16.34c1.46,0,2.64,1.18,2.64,2.64Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,600.87l-28.66,55.25c-.19.38-.3.79-.3,1.22v28.59c0,1.46-1.18,2.64-2.64,2.64h-13.08c-1.46,0-2.64-1.18-2.64-2.64v-28.58c0-.42-.1-.84-.3-1.22l-28.78-55.24c-.92-1.76.36-3.86,2.34-3.86h14.69c1.02,0,1.95.59,2.39,1.52l16.56,35.22c.95,2.03,3.84,2.02,4.78,0l16.45-35.21c.43-.93,1.37-1.52,2.39-1.52h14.44c1.98,0,3.26,2.1,2.34,3.86Z",
    fill: "#000",
    strokeWidth: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "k0ajHK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M767.08,144.15c.12,6.26-3.38,10.66-10.78,13.52-95.22,36.69-190.45,73.36-285.67,110.05-14.7,5.65-29.47,11.12-44.07,17.02-12.93,5.23-25.48,5-38.46-.02-96.73-37.38-193.54-74.6-290.33-111.88-5.55-2.14-5.55-2.12-5.55,3.64v60.06c0,14.98.03,29.97,0,44.96-.01,5.53-4.51,10.01-10.04,10.01h0c-5.54,0-10.03-4.48-10.03-10.02-.05-37.86-.07-75.73.07-113.61,0-3.8-.98-5.82-4.74-6.81-3.19-.83-6.24-2.3-9.34-3.5-7.1-2.77-10.33-6.96-10.29-13.36.06-6.24,3.15-10.27,10.13-12.96,25.85-9.99,51.7-19.95,77.57-29.9C220.3,68.68,305.08,36.07,389.85,3.39c11.71-4.51,23.29-4.52,35.02-.02,110.78,42.69,221.56,85.32,332.34,127.97,6.35,2.44,9.78,6.92,9.88,12.81Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.65,235.04v-4.07c-2.36-.14-4.07.94-5.86,1.63-60.75,23.37-121.5,46.76-182.23,70.19-15.56,6-32.78,6-48.32,0-62.15-23.96-124.33-47.86-186.46-71.89-3.72-1.44-4.72-1.16-4.7,3.15.16,36.26.14,92.17.04,128.43,0,3.5.89,4.72,4.64,4.56,16.58-.73,33.09.49,49.36,3.56,54.79,10.35,100.21,35.43,136.37,75.01,3.01,3.31,6.67,5.88,10.7,7.63,4.03,1.75,8.4,2.68,12.89,2.68,8.93,0,17.51-3.66,23.55-10.25,48.16-52.59,109.68-78.85,184.47-78.61,4.45.02,5.67-1,5.65-5.41-.16-35.65-.1-90.97-.1-126.62ZM436.88,362.72c-.47.53-1,.49-1.3.45h-.08c-5.33-.1-11.53-.12-17.74.63-2.68.33-5.8.83-8.85,2.01-1.89.75-3.44,1.91-4.76,3.58-2.36,3.01-2.18,6.87.37,8.99,2.22,1.83,4.54,2.09,7.28.85,3.32-1.51,6.32-2.52,9.11-3.07,1.46-.3,3.29-.65,4.92.26.37.2.77.41,1,.92.45.96,1.24,1.53,2.26,2.07.04.02.1.04.16.08,1.1.49,1.08,1.1.96,1.51-.24.87-.96.9-1.57.87h-1.51c-.98,0-2.01,0-3.03.08-1.1.1-1.85-.45-2.34-.87-.08-.08-.14-.16-.22-.22l-.35-.35-.18.47c-.04.1-.08.18-.16.28-.3.37-.71.39-1.55.45-2.56.12-4.8.77-6.91,2.01-1.59.94-2.91,2.26-3.91,3.9-.67,1.08-.73,2.28-.75,3.62v1.06c.02.92.04,1.89-.08,2.87-.53,4.54-2.5,7.5-6.02,9.03-3.01,1.32-6.33,2.11-10.51,2.52l-.2.02c-.16.02-.33.04-.53.04-.45,0-.85-.14-1.18-.39l-.83-.65.96-.39c.35-.14.69-.28,1.04-.41l.18-.08c.81-.31,1.61-.65,2.4-.98,1.99-.87,4.05-1.83,5.88-3.4,2.16-1.89,3.21-4.19,3.17-7.06-.04-2.93-.94-5.55-1.93-7.93-1.2-2.95-2.46-6-2.99-9.34-.3-1.93-.28-3.7.1-5.35.71-3.23,2.66-5.63,5.92-7.34,2.7-1.4,5.74-2.3,9.36-2.77,7.61-.96,15.01-.26,21.25.57l.51.06c.77.1,1.55.2,2.36.45l.89.28-.61.71Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 293.65,
    width: 4.91,
    height: 78.51,
    rx: 2.45,
    ry: 2.45,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.88,
    y: 293.65,
    width: 4.91,
    height: 78.51,
    rx: 2.45,
    ry: 2.45,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.89,
    y: 293.65,
    width: 4.91,
    height: 78.51,
    rx: 2.45,
    ry: 2.45,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.9,
    y: 293.65,
    width: 4.91,
    height: 78.51,
    rx: 2.45,
    ry: 2.45,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 293.65,
    width: 4.91,
    height: 78.51,
    rx: 2.45,
    ry: 2.45,
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyfvsdlogostacked);
export default __webpack_public_path__ + "static/media/my fvsd logo stacked.c9c54e8054ac63a9b46b1b73c9391220.svg";
export { ForwardRef as ReactComponent };